import Logger from '../lib/Logger';
import { Tracker } from '../store/tracking/action-creators';
import { shouldUpdateTrellisTheme } from '../http-survey/trellisGate';
const LOG = Logger.getLogger('redirectToUrl');
export const redirectToUrl = (url, shouldRedirectWindow = true) => (dispatch, getState) => {
  if (!url || typeof url === 'string' && url.trim() === '') {
    LOG.error('Redirecting to a null or empty url');
    return;
  }
  let finalUrl = url;
  const state = getState();
  const updateTrellisTheme = shouldUpdateTrellisTheme(state);
  if (updateTrellisTheme) {
    const targetUrl = new URL(url, window.location.href);
    targetUrl.searchParams.set('__initialHubspotTheme', 'trellis-light');
    targetUrl.searchParams.set('resetNavConfig', 'true');
    finalUrl = targetUrl.toString();
  }
  dispatch(Tracker.redirect({
    url: finalUrl
  }));
  if (shouldRedirectWindow) {
    window.location.replace(finalUrl);
  }
};